import {
  changeNameService,
  fetchUserSettings,
  updateLocale,
  updatePassword,
} from '../services/userProfileService';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const requestUserSettings = createAsyncThunk(
  'userSettings/requestUserSettings',
  async () => {
    const response = await fetchUserSettings();
    return response.data;
  }
);

export const changeName = createAsyncThunk(
  'userSettings/changeName',
  async (name) => {
    const response = await changeNameService({ name });
    return response.data;
  }
);

export const changeLocale = createAsyncThunk(
  'userSettings/changeLocale',
  async (locale) => {
    const response = await updateLocale({ locale });
    return response.data;
  }
);
export const changePassword = createAsyncThunk(
  'userSettings/changePassword',
  async (
    { currentPassword, newPassword, newRepeatedPassword },
    { rejectWithValue }
  ) => {
    try {
      await updatePassword({
        currentPassword,
        password: newPassword,
        repeatedPassword: newRepeatedPassword,
      });
      return null;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// slice
const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState: {
    isFetchingUserSettings: true,
    changePasswordError: null,
    locales: {},
    name: '',
    locale: '',
  },
  reducers: {
    setChangePasswordError(state, action) {
      state.changePasswordError = action.payload;
    },
    userSettingsReceived(state, action) {
      state.isFetchingUserSettings = false;
      Object.assign(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestUserSettings.pending, (state) => {
        state.isFetchingUserSettings = true;
      })
      .addCase(requestUserSettings.fulfilled, (state, action) => {
        state.isFetchingUserSettings = false;
        Object.assign(state, action.payload);
      })
      .addCase(requestUserSettings.rejected, (state) => {
        state.isFetchingUserSettings = false;
      })
      .addCase(changeName.pending, (state) => {
        state.isFetchingUserSettings = true;
      })
      .addCase(changeName.fulfilled, (state, action) => {
        state.name = action.payload.name;
        state.locales = action.payload.locales;
      })
      .addCase(changeName.rejected, (state) => {
        state.isFetchingUserSettings = false;
      })
      .addCase(changeLocale.pending, (state) => {
        state.isFetchingUserSettings = true;
      })
      .addCase(changeLocale.fulfilled, (state, action) => {
        const { localeData, locales } = action.payload;
        window.CHAMP.locale.data.map = localeData.translations;
        window.CHAMP.locale.data.locale = localeData.code;
        state.locale = localeData.code;
        state.locales = locales;
      })
      .addCase(changeLocale.rejected, (state) => {
        state.isFetchingUserSettings = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.changePasswordError = action.payload;
      });
  },
});

export default userSettingsSlice.reducer;
export const { setChangePasswordError, userSettingsReceived } =
  userSettingsSlice.actions;
export const userSettingsSelectors = {
  selectIsFetchingUserSettings: (state) =>
    state.userSettings.isFetchingUserSettings,
  selectChangePasswordError: (state) => state.userSettings.changePasswordError,
  selectLocales: (state) => state.userSettings.locale,
  selectName: (state) => state.userSettings.name,
};
